let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gKYwM")).then(() => parcelRequire('4LKV2'));